import Holidays, {HolidaysTypes} from 'date-holidays';
import store from '@/store';

export interface ExtendedHolidays {
    countryAndStateString: string;
    holidayCountry: HolidaysTypes.Country;
}

class HolidayService {

    private holidayCountriesAndStates: ExtendedHolidays[] = (() => {
        const result: ExtendedHolidays[] = [];

        const dateHoliday = new Holidays();

        const allCountries = dateHoliday.getCountries(); // e.g. {de: 'Deutschland', ...}
        for (const currentCountryKey of Object.keys(allCountries)) { // e.g. 'de'
            const currentCountryName = allCountries[currentCountryKey]; // e.g. 'Deutschland'

            const allCountryStates = dateHoliday.getStates(currentCountryKey);
            if (allCountryStates) {
                for (const currentCountryStateKey of Object.keys(allCountryStates)) { // e.g. 'RP'
                    const currentCountryStateName = allCountryStates[currentCountryStateKey];

                    result.push({
                        countryAndStateString: currentCountryName + ' / ' + currentCountryStateName,
                        holidayCountry: {
                            country: currentCountryKey,
                            state: currentCountryStateKey
                        }
                    });
                }
            } else {
                result.push({
                    countryAndStateString: currentCountryName,
                    holidayCountry: {
                        country: currentCountryKey
                    }
                });
            }
        }

        return result;
    })();

    public getAllPossibleValues() {
        return this.holidayCountriesAndStates;
    }

    public getHolidays() {
        let result: Holidays | null = null;
        const user = store.state.user;
        const compareString = this.buildCompareString((user.holiday || {}).country, (user.holiday || {}).state);
        if (compareString) {
            for (const currentCfg of this.holidayCountriesAndStates) {
                if (currentCfg.countryAndStateString === compareString) {
                    result = new Holidays(currentCfg.holidayCountry);
                    break;
                }
            }
        }
        return result;
    }

    getDefault() {
        let result: ExtendedHolidays | null = null;
        const user = store.state.user;
        const compareString = this.buildCompareString((user.holiday || {}).country, (user.holiday || {}).state);
        if (compareString) {
            for (const currentCfg of this.holidayCountriesAndStates) {
                if (currentCfg.countryAndStateString === compareString) {
                    result = currentCfg;
                    break;
                }
            }
        }
        return result;
    }

    getFromHolidayDto(newValue: DisguiseDto.HolidayDto) {
        let result: ExtendedHolidays | null = null;

        const compareString = this.buildCompareString(newValue?.country, newValue?.state);
        if (compareString) {
            for (const currentCfg of this.holidayCountriesAndStates) {
                if (currentCfg.countryAndStateString === compareString) {
                    result = currentCfg;
                }
            }
        }
        return result;
    }

    private buildCompareString(country?: string, state?: string) {
        const holidays = new Holidays();

        let fullCountryName;
        let fullStateName;

        if (country) {
            fullCountryName = holidays.getCountries()[country];

            if (state) {
                fullStateName = holidays.getStates(country)[state];
            }
        }

        let compareString: string = '';
        if (fullCountryName) {
            compareString += fullCountryName;
            if (fullStateName) {
                compareString += ' / ' + fullStateName;
            }
        }
        return compareString;
    }

}

const AMETRAS_HOLIDAY_UTILS_INST = new HolidayService();

export {AMETRAS_HOLIDAY_UTILS_INST};
